import { render, staticRenderFns } from "./parallaxScrollingFlip.vue?vue&type=template&id=55408ff0&scoped=true&"
import script from "./parallaxScrollingFlip.vue?vue&type=script&lang=js&"
export * from "./parallaxScrollingFlip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55408ff0",
  null
  
)

export default component.exports